import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { db } from '../../services/firebase';
import { collection, query, orderBy, limit, onSnapshot } from 'firebase/firestore';

const LiveView = () => {
  const { isDemo } = useAuth();
  const [checadas, setChecadas] = useState([]);
  const [usuarios, setUsuarios] = useState({}); // Objeto { uid: nombre }
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (isDemo) {
      setChecadas([]);
      setUsuarios({ 'demo-user': 'Usuario Demo' });
      setLoading(false);
      return;
    }

    // Escuchar usuarios
    const usuariosQuery = query(collection(db, 'usuarios'));
    const unsubscribeUsuarios = onSnapshot(
      usuariosQuery,
      (snapshot) => {
        const mapa = {};
        snapshot.forEach((doc) => {
          const data = doc.data();
          mapa[doc.id] = data.nombre || data.email || doc.id;
        });
        setUsuarios(mapa);
      },
      (error) => {
        console.error('Error al cargar usuarios:', error);
      }
    );

    // Escuchar checadas
    const checadasQuery = query(
      collection(db, 'checadas'),
      orderBy('timestamp', 'desc'),
      limit(50)
    );
    const unsubscribeChecadas = onSnapshot(
      checadasQuery,
      (snapshot) => {
        const items = [];
        snapshot.forEach((doc) => {
          items.push({
            id: doc.id,
            ...doc.data(),
            timestamp: doc.data().timestamp?.toDate()
          });
        });
        setChecadas(items);
        setLoading(false);
      },
      (error) => {
        console.error('Error al escuchar checadas:', error);
        setError('No se pudo cargar la vista en vivo.');
        setLoading(false);
      }
    );

    // Limpiar suscripciones
    return () => {
      unsubscribeUsuarios();
      unsubscribeChecadas();
    };
  }, [isDemo]);

  const getIconoTipo = (tipo) => {
    const iconos = {
      entrada: '🚪',
      salida_comida: '🍽️',
      entrada_comida: '🔙',
      salida: '🏠'
    };
    return iconos[tipo] || '✅';
  };

  const formatHora = (fecha) => {
    if (!fecha) return '--:--';
    return fecha.toLocaleTimeString('es-MX', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  return (
    <div className="live-view">
      <h3>🔴 Vista en Vivo - Últimas Checadas</h3>

      {loading && <p>Cargando...</p>}
      {error && <div className="error-message">{error}</div>}

      {!loading && !error && (
        <div className="table-wrapper">
          <table className="erp-table">
            <thead>
              <tr>
                <th>Tipo</th>
                <th>Usuario</th>
                <th>Fecha/Hora</th>
                <th>Ubicación / Sucursal</th>
              </tr>
            </thead>
            <tbody>
              {checadas.map((item) => {
                const isFuera = item.fueraDeSucursal === true || (item.ubicacion && item.ubicacion.withinGeofence === false);
                return (
                  <tr key={item.id}>
                    <td>{getIconoTipo(item.tipo)} {item.tipo}</td>
                    <td>{usuarios[item.userId] || item.userId}</td>
                    <td>{item.timestamp ? item.timestamp.toLocaleString('es-MX') : 'Sin fecha'}</td>
                    <td>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                        {isFuera ? (
                          <span className="badge badge-warning" style={{ background: '#fef3c7', color: '#b45309', border: '1px solid #fde68a', fontWeight: 600 }}>
                            ⚠️ Fuera ({item.ubicacion?.distance !== undefined && item.ubicacion?.distance !== null ? `${item.ubicacion.distance}m` : 'Sin GPS'})
                          </span>
                        ) : (
                          <span className="badge badge-success">
                            ✅ {item.ubicacion?.sucursalNombre || 'En sucursal'} ({item.ubicacion?.distance ?? 0}m)
                          </span>
                        )}

                        {item.ubicacion?.latitude && item.ubicacion?.longitude && (
                          <a
                            href={`https://www.google.com/maps?q=${item.ubicacion.latitude},${item.ubicacion.longitude}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Ver en Google Maps"
                            style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '4px',
                              padding: '3px 8px',
                              borderRadius: '6px',
                              background: '#eff6ff',
                              color: '#2563eb',
                              border: '1px solid #bfdbfe',
                              fontSize: '0.75rem',
                              fontWeight: 600,
                              textDecoration: 'none'
                            }}
                          >
                            <i className="fa-solid fa-map-location-dot"></i> Maps
                          </a>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default LiveView;